import React from 'react';
import PropTypes from 'prop-types';
import * as S from './MenuItem.styled';
import { Link } from 'react-router-dom';
import { useTheme } from 'styled-components';

const MenuItem = ({ text, icon, url, isActive, disabled, onClick }) => {
  const theme = useTheme();
  return (
    <S.Container onClick={onClick}>
      <Link to={url}>
        <S.MenuItem theme={theme} isActive={isActive} disabled={disabled} text={text}>
          {icon && <S.IconWrapper>{icon}</S.IconWrapper>}
          <span>{text}</span>
        </S.MenuItem>
      </Link>
    </S.Container>
  );
};

MenuItem.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  url: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

export default MenuItem;
